import React from 'react';
import projaimg from '../project_logos/aashniandco.jpeg';
import projcimg from '../project_logos/shark-tank-india-logo.png';
import projdimg from '../project_logos/kbc.png';
import projeimg from '../project_logos/myitreturnlogo.png';
import magentoImg from '../skill_show/magento.png';
import phpImg from '../skill_show/php.png';
import jsImg from '../skill_show/js.png';
import sqlImg from '../skill_show/mysql.png';
import nodeImg from '../skill_show/nodelogo.png';
import projbimg from '../project_logos/online-voting-system.png';
import htmlImg from '../skill_show/html.png';
import cssImg from '../skill_show/css.png';

export default function Projects() {
  return (
    <>
    <div className="subheadings projects">
        <h1>Projects</h1>
        {/* <div className="search-projects">
            <input type="text" className="form-control searchsubheadings searchprojectsinput" placeholder="Search..." aria-label="Username" aria-describedby="basic-addon1"/>
        </div> */}

        <div className="project-collection">
            <div className="card project-card project-e">
                <div className="projectcard-body">
                    <div className="project-image-head">
                        <img src={projeimg} className='projeimg' alt='projeimg'/>
                    </div>
                    <div className="project-title">
                        <div className="title-name">MyITReturn</div>
                        <div className="project-link">
                            <a href='https://myitreturn.com/' className='projelink'>
                                <i className="fa-solid fa-link"></i>
                            </a>
                        </div>
                    </div>
                    <hr/>
                    <div className="project-desc">
                        Government compliant tax filing platform, implementing feature enhancements and regulatory updates to ensure accurate and seamless ITR submission. Maintained backend logic, validations and UI updates while ensuring system stability during high-traffic filing periods.
                    </div>
                    <div className="project-duration">
                        <div className="dur-card dur-start">
                            June-2025
                        </div>
                        <div className="dur-card dur-end">
                            Present
                        </div>
                    </div>
                    <hr/>
                    <div className="project-tech-stack">
                        <div className="tech-img">
                            <img src={phpImg} className='tech-img-a' alt='tech-img-a'/>
                        </div>
                        <div className="tech-img">
                            <img src={jsImg} className='tech-img-b' alt='tech-img-b'/>
                        </div>
                        <div className="tech-img">
                            <img src={sqlImg} className='tech-img-c' alt='tech-img-c'/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card project-card project-d">
                <div className="projectcard-body">
                    <div className="project-image-head">
                        <img src={projdimg} className='projdimg' alt='projdimg'/>
                    </div>
                    <div className="project-title">
                        <div className="title-name">KBC Online game</div>
                        {/* <div className="project-link">
                            <a href='javascript:void()' className='projdlink'>
                                <i className="fa-solid fa-link"></i>
                            </a>
                        </div> */}
                    </div>
                    <hr/>
                    <div className="project-desc">
                        A quiz based web application inspired by Kaun Banega Crorepati with dynamic question flow, score-calculation, and user progression logic. Implemented serverside rendering and game logic using Node js and EJS.
                    </div>
                    <div className="project-duration">
                        <div className="dur-card dur-start">
                            March-2025
                        </div>
                        <div className="dur-card dur-end">
                            May-2025
                        </div>
                    </div>
                    <hr/>
                    <div className="project-tech-stack">
                        <div className="tech-img">
                            <img src={nodeImg} className='tech-img-a' alt='tech-img-a'/>
                        </div>
                        <div className="tech-img">
                            <img src={jsImg} className='tech-img-b' alt='tech-img-b'/>
                        </div>
                        <div className="tech-img">
                            <img src={sqlImg} className='tech-img-c' alt='tech-img-c'/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card project-card project-c">
                <div className="projectcard-body">
                    <div className="project-image-head">
                        <img src={projcimg} className='projcimg' alt='projcimg'/>
                    </div>
                    <div className="project-title">
                        <div className="title-name">Shark Tank Admin Panel</div>
                        {/* <div className="project-link">
                            <a href='javascript:void()' className='projclink'>
                                <i className="fa-solid fa-link"></i>
                            </a>
                        </div> */}
                    </div>
                    <hr/>
                    <div className="project-desc">
                        Enhanced an existing admin dashboard used to manage Shark Tank participant data, including CRUD operations and workflow improvements. Improved data handling and UI behavior for efficient administration and data accuracy. Worked on backend and frontend changes to support business-specific requirements.
                    </div>
                    <div className="project-duration">
                        <div className="dur-card dur-start">
                            Feb-2025
                        </div>
                        <div className="dur-card dur-end">
                            May-2025
                        </div>
                    </div>
                    <hr/>
                    <div className="project-tech-stack">
                        <div className="tech-img">
                            <img src={phpImg} className='tech-img-b' alt='tech-img-b'/>
                        </div>
                        <div className="tech-img">
                            <img src={jsImg} className='tech-img-c' alt='tech-img-c'/>
                        </div>
                        <div className="tech-img">
                            <img src={sqlImg} className='tech-img-d' alt='tech-img-d'/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card project-card project-a">
                <div className="projectcard-body">
                    <div className="project-image-head">
                        <img src={projaimg} className='projaimg' alt='projaimg'/>
                    </div>
                    <div className="project-title">
                        <div className="title-name">Aashni + Co</div>
                        <div className="project-link">
                            <a href='https://aashniandco.com/' className='projalink'>
                                <i className="fa-solid fa-link"></i>
                            </a>
                        </div>
                    </div>
                    <hr/>
                    <div className="project-desc">
                        An E-commerce website having product catalog size over lakhs and multiple heirarchical structure. Role to maintain backend and implement new features by creating new modules which can be reused on multiple magento websites.
                    </div>
                    <div className="project-duration">
                        <div className="dur-card dur-start">
                            April-2023
                        </div>
                        <div className="dur-card dur-end">
                            December-2024
                        </div>
                    </div>
                    <hr/>
                    <div className="project-tech-stack">
                        <div className="tech-img">
                            <img src={magentoImg} className='tech-img-a' alt='tech-img-a'/>
                        </div>
                        <div className="tech-img">
                            <img src={phpImg} className='tech-img-b' alt='tech-img-b'/>
                        </div>
                        <div className="tech-img">
                            <img src={jsImg} className='tech-img-c' alt='tech-img-c'/>
                        </div>
                        <div className="tech-img">
                            <img src={sqlImg} className='tech-img-d' alt='tech-img-d'/>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="card project-card project-b">
                <div className="projectcard-body">
                    <div className="project-image-head">
                        <img src={projbimg} className='projbimg' alt='projbimg'/>
                    </div>
                    <div className="project-title">
                        <div className="title-name">Online Voting System</div>
                        <div className="project-link">
                            <a href='https://github.com/nayaab-phansopkar/onlinevoting' className='projalink'>
                                <i className="fa-solid fa-link"></i>
                            </a>
                        </div>
                    </div>
                    <hr/>
                    <div className="project-desc">
                        A centralized online voting system based on booth wise voting.
                    </div>
                    <div className="project-duration">
                        <div className="dur-card dur-start">
                            March-2023
                        </div>
                        <div className="dur-card dur-end">
                            March-2023
                        </div>
                    </div>
                    <hr/>
                    <div className="project-tech-stack">
                        <div className="tech-img">
                            <img src={phpImg} className='tech-img-a' alt='tech-img-a'/>
                        </div>
                        <div className="tech-img">
                            <img src={htmlImg} className='tech-img-b' alt='tech-img-b'/>
                        </div>
                        <div className="tech-img">
                            <img src={cssImg} className='tech-img-c' alt='tech-img-c'/>
                        </div>
                        <div className="tech-img">
                            <img src={jsImg} className='tech-img-d' alt='tech-img-d'/>
                        </div>
                        <div className="tech-img">
                            <img src={sqlImg} className='tech-img-d' alt='tech-img-e'/>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
    </>
  )
}
